import { defineComponent } from "vue";
import SimTariffs from "@/components/sim-tariffs.vue";
import { FormKit } from "@formkit/vue";

export default defineComponent({
  template: `
        <SimTariffs />
    `,
  name: "SimTariffsWrapper",
  components: { FormKit, SimTariffs },
});
